module.exports = __webpack_public_path__ + "img/riley-logo-white.0fa2a047.png";